// import InputGroup from "../../../../components/FormComponent/InputGroup";
import Layout from "../../../../components/Layout";
import BreadCrumb from "../../../../components/BreadCrumb";
import { toast } from "react-toastify";
import Button from "../../../../components/Button";
import useStyles from "../../styles";
// import PaymentCard from "../../../../components/CardCount/PaymentCard";
import { TableSearch } from "../../../../components/Table/TableActions";
import Table from "../../../../components/Table/Table";
import Modal from "../../../../components/Modal";
import { Icon } from "@iconify/react/dist/iconify.js";
// import PaymentRow from "./PaymentRow";
import { Grid } from "@mui/material";
import Badge from "../../../../components/Badge";
// import { useUserState } from "../../../../context/UserContext";
// import logo from "../../../../assets/images/logo.svg";
// import PaymentRow from "./PaymentRow";
import { useParams, useNavigate } from "react-router-dom";
import { httprequest } from "../../../../data/api";
import { useEffect, useState } from "react";
import PageLoader from "../../../../components/PageLoader";
import useWindowSize from "../../../../hooks/useWindow";
import { PaymentMethod } from "../../../../utils/DropDown";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import InputGroup from "../../../../components/FormComponent/InputGroup";

const STUDENT_INVOICE = "/api/v1/invoices/student-invoices/students/";
const STUDENT_ENDPOINT = "/api/v1/students";
// const STUDENT_INVOICE = "/api/v1/student-invoice";

const StudentListDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const [cancelModal, setCancelModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [invoice, setInvoice] = useState({});
  const [studentinvoice, setStudentsInvoice] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [appoveModal, setApproveModal] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(false);
  const [approveItems, setApproveItems] = useState({});
  const [uploadForm, setUploadForm] = useState({});
  const [selectedFile, setSelectedFile] = useState("");
  const [studentLoading, setStudentLoading] = useState(false);
  const [studentData, setStudentData] = useState([]);
  const [addTransactionModal, setAddTransactionModal] = useState(false);
  const width = useWindowSize();
  const mobile = width < 600;

  /**
 * Fetches class invoices for all students
 * @function getStudentListDetail
 * @async
 * @description Retrieves invoice data for a class including student list and sets loading state
 * @throws {Error} Silently handles errors and stops loading indicator
 */
  const getStudentListDetail = () => {
    setIsLoading(true);
    httprequest
      .get(`${STUDENT_INVOICE}${id}/transactions`)
      .then((res) => {
        setStudentsInvoice(res?.data?.data);
        setSearchResult(res?.data?.data);
        setIsLoading(false);
      }).catch(() => {
        setIsLoading(false);
      });
  };

  const getStudent = () => {
    setStudentLoading(true);
    httprequest.get(`${STUDENT_ENDPOINT}/${id}`)
      .then((res) => {
        setStudentLoading(false);
        setStudentData(res?.data?.data);
      }).catch((err) => {
        setStudentLoading(false);
        toast.error(err?.response?.data);
      });
  };

  const handleTransactionModal = () => {
    setAddTransactionModal(!addTransactionModal);
  };

  /**
 * Fetches a specific student's invoice details
 * @function getStudentInvoice
 * @async
 * @param {string} invoice_no - The invoice number to fetch
 * @description Retrieves detailed invoice data for a specific student
 * @throws {Error} Silently handles errors and stops loading indicator
 */
  // const getStudentInvoice = (invoice_no) => {
  //   setIsStudentInvoiceLoading(true);
  //   httprequest
  //     .get(`${STUDENT_INVOICE}/${invoice_no}`)
  //     .then((res) => {
  //       setAStudentInvoice(res?.data?.data);
  //       setIsStudentInvoiceLoading(false);
  //     }).catch(() => {
  //       setIsStudentInvoiceLoading(false);
  //     });
  // };

  /**
 * Closes cancel modal and navigates back to invoices page
 * @function handleCloseCancelModal
 */
  const handleCloseCancelModal = () => {
    setCancelModal(false);
    navigate("/payment/invoice");
  };

  /**
 * Toggles invoice modal and fetches student invoice data
 * @function handleInvoiceModal
 * @param {Object} row - The invoice row data containing invoice_no
 */
  // const handleInvoiceModal = (row) => {
  //   getStudentInvoice(row?.invoice_no);
  //   setInvoiceModal(!invoiceModal);
  // };

  /**
 * Closes the invoice detail modal
 * @function handleCloseInvoiceModal
 */
  // const handleCloseInvoiceModal = () => {
  //   setInvoiceModal(false);
  // };

  const handleApproveModal = (row) => {
    setApproveItems(row);
    setApproveModal(!appoveModal);
  };

  const handlePaymentDetails = (row) => {
    setPaymentDetails(!paymentDetails);
    setApproveItems(row);
  };

  // This function handles the file change when creating a notice
  const handleFileChange = (e) => {
    // const { name } = e.target;
    if (e.target.files) setSelectedFile(e.target.files[0]);
    setUploadForm({
      ...uploadForm,
      file: e.target.files[0].name.replaceAll(" ", "-")
    });
  };
  const handleRemoveFile = () => setSelectedFile("");

  /**
 * Table columns configuration for student invoices
 * @type {Array<Object>} columns
 * @property {string} name - Column header text
 * @property {Function} selector|cell - Cell content renderer
 * @property {boolean} [center] - Center align content
 * @property {boolean} [sortable] - Enable/disable sorting
 */
  const columns = [
    {
      name: "Invoice No.",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Invoice No</p>}
          {row?.invoice_no || "--/--"}
        </>
      )
    },
    {
      name: "Invoice Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Invoice Name</p>}
          {`${row?.invoice_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Amount",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Amount</p>}
          {row?.amount}
        </>
      )
    },
    {
      name: "Structure Type",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">structure_type</p>}
          {row?.amount}
        </>
      )
    },
    {
      name: "Payment Method",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Payment Method</p>}
          {row?.payment_method}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row?.status} />
    }
    // {
    //   name: "",
    //   center: true,
    //   sortable: false,
    //   cell: (row) => (
    //     <div key={row?.id} className="table-action-container">
    //       <button className="table-action-icon" onClick={() => handleApproveModal(row)}>
    //         <Icon icon="octicon:person-16" />
    //       </button>
    //       <button onClick={() => handlePaymentDetails(row)} className="table-action-icon">
    //         <Icon icon="fluent:eye-16-regular" />
    //       </button>
    //       <button className="table-action-icon delete-icon">
    //         <Icon icon="iconoir:telegram" />
    //       </button>
    //     </div>
    //   )
    // }
  ];

  /**
 * Fetches class invoices on component mount
 * @effect
 * @listens Mount
 */
  useEffect(() => {
    getStudentListDetail();
    getStudent();
  }, []);

  /**
 * Handles student invoice search functionality
 * @function handleSearchStudentInvoice
 * @param {Object} e - The input change event
 * @description Filters invoices based on multiple search terms across various fields
 */
  const handleSearchStudentInvoice = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = studentinvoice?.filter((data) => valArray?.every(
      (word) => data?.status
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                            data?.invoice_name
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                            data?.structure
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                              data?.invoice_no
                                ?.toLowerCase()
                                .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  // const total = payments.reduce((sum, payment) => sum + payment?.amount, 0);

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/payment/student-list"
                link_one_name="All Student List"
                active="Student Invoice Details"
                description="View student payment history"
              />
            </div>
            {/* <div className="flex gap-10">
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                onClick={handleTransactionModal}
                buttonName="Add Transacction"
              />
            </div> */}
          </div>
          <div>
            {studentLoading ? <PageLoader /> : (
              <>
                <div className="page-content padding-equal margin-bottom-14">
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>First Name</p>
                          <h4>{studentData?.first_name || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Last Name</p>
                          <h4>{studentData?.last_name || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Email</p>
                          <h4>{studentData?.email || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Age</p>
                          <h4>{studentData?.age || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Gender</p>
                          <h4>{studentData?.gender || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Created At</p>
                          <h4>{studentData?.created_at?.substring(0, 10) || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <Table data={searchResult} columns={columns} subHeader={true} pagination isLoading={isLoading} subHeaderComponent={
                    studentinvoice?.length > 0 && (
                      <TableSearch placeholder="Search here..." searchTableFunc={handleSearchStudentInvoice} />
                    )
                  }
                  />
                </div>
              </>
            )}
          </div>
          <Modal
            title="Cancel"
            subtitle={
              <div>
            Are you sure you want to cancel ?
              </div>
            }
            modalContent={<></>}
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="dangeroutline"
                    buttonSize="full"
                    color="btndanger"
                    buttonName="Go Back"
                    onClick={handleCloseCancelModal}
                  />
                  <Button
                    variant="danger"
                    buttonName="Yes, Cancel"
                    buttonSize="full"
                    color="btndefault"
                    onClick={() => navigate("/payment/overview")}
                  />
                </div>
              </>
            }
            isopen={cancelModal}
            closeModal={handleCloseCancelModal}
          />
          <Modal
            title="Payment Approval"
            subtitle="Please send to the immediately because you wont be able to see this password again"
            modalContent={
              <div className="margin-top-16">
                <Grid container spacing={2}>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Parents Name</p>
                        <h4>{approveItems?.session?.session || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Amount Due</p>
                        <h4>{approveItems?.term?.term || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Amount paid</p>
                        <h4>{approveItems?.structure_type || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Amount paid</p>
                        <h4>{approveItems?.structure_type || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Created On</p>
                        <h4>{approveItems?.created_at || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Due On</p>
                        <h4>{approveItems?.due_date || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={classes.quelabel}>Comment <span className="input-required"> *</span></label>
                    <div className={classes.textandimg}>
                      <textarea
                        type="text"
                        placeholder="Enter comment"
                        name="description"
                        // onChange={handleChange}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            }
            modalFooter={
              <>
                <Grid container spacing={2}>
                  <Grid item lg={3} md={6} sm={6} xs={12}>
                    <Button variant="primaryoutline" buttonName="Decline" buttonSize="full" color="btnfontprimary" />
                  </Grid>
                  <Grid item lg={3} md={6} sm={6} xs={12}>
                    <Button variant="primary" buttonName="Approve" buttonSize="full" color="btndefault" />
                  </Grid>
                  <Grid item lg={3} md={6} sm={6} xs={12}>
                    <Button variant="primary" buttonName="Request Info" buttonSize="full" color="btndefault" />
                  </Grid>
                  <Grid item lg={3} md={6} sm={6} xs={12}>
                    <Button variant="primary" buttonName="Double Entry" buttonSize="full" color="btndefault" />
                  </Grid>
                </Grid>
              </>
            }
            isopen={appoveModal}
            closeModal={handleApproveModal}
          />
          {/* Add a Transaction */}
          <Modal
            title="Add a Transaction"
            subtitle={
              <div>
                Manually record a payment received in cash for tuition, fees, or other charges.
              </div>
            }
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Payment Method"
                      required
                      children={
                        <select name="payment_method">
                          <option value="">---Select Labels ---</option>
                          {PaymentMethod?.map((data) => {
                            return (
                              <option value={data.key} key={data?.key}>
                                {data?.text}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Amount"
                      required
                      margin="normal"
                      placeHolder="Add amount"
                      inputType="text"
                      inputName="title"
                      // onChange={handleChange}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={classes.quelabel}>Description <span className="input-required"> *</span></label>
                    <div className={classes.textandimg}>
                      <textarea
                        type="text"
                        placeholder="Enter description"
                        name="description"
                      />
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <p className="text-align-left no-margin-block">
                      <strong>Upload Image</strong>
                      {/* <span className="input-required">*</span> */}
                    </p>
                    <div className={classes.pickercontainers}>
                      <input
                        type="file"
                        required
                        className={classes.picker}
                        onChange={handleFileChange}
                        name="file"
                        accept=".png, .jpg"
                      />

                      <div className={classes.uploadflex}>
                        <div>
                          <Icon
                            icon="icon-park-outline:upload-two"
                            className={classes.uploadicon}
                          />
                        </div>
                        {selectedFile?.name ? (
                          <div>
                            <h2 className={classes.uploadtitle}>
                              {selectedFile?.name}
                            </h2>
                          </div>
                        ) : (
                          <div>
                            <p className={classes.uploadtitle}>
                                        Tap to Upload
                            </p>
                            <p className={classes.uploadsubtitle}>
                                        JPG, PNG | 10MB max.
                            </p>
                          </div>
                        )}
                      </div>
                      <div className={classes.rightpicker}>
                        {selectedFile?.name ? (
                          <div
                            className={classes.uploadbutton}
                            onClick={handleRemoveFile}
                          >
                            <Icon icon="zondicons:minus-solid" /> Remove File
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* {noticeValidator.message("file", selectedFile, "required")} */}
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonName="Add Transaction"
                  buttonSize="full"
                  color="btndefault"
                  // onClick={handleCreateNotice}
                  // isLoading={isLoading}
                />
              </>
            }
            isopen={addTransactionModal}
            closeModal={handleTransactionModal}
          />
          <Modal
            title="Transaction Details"
            subtitle="See all your transaction details here"
            modalContent={
              <div className="margin-top-16">
                <Grid container spacing={2}>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Total Amount</p>
                        <h4>{approveItems?.session?.session || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Payment Typw</p>
                        <h4>{approveItems?.term?.term || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Paid By</p>
                        <h4>{approveItems?.structure_type || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Paid For</p>
                        <h4>{approveItems?.structure_type || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Amount Paid</p>
                        <h4>{approveItems?.created_at || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Transaction Id</p>
                        <h4>{approveItems?.due_date || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={classes.quelabel}>Description <span className="input-required"> *</span></label>
                    <div className={classes.textandimg}>
                      <textarea
                        type="text"
                        placeholder="Enter comment"
                        name="description"
                        // onChange={handleChange}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            }
            modalFooter={
              <>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Button variant="primaryoutline" buttonName="Send Receipts" buttonSize="full" color="btnfontprimary" />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Button variant="primary" buttonName="Download Receipts" buttonSize="full" color="btndefault" />
                  </Grid>
                </Grid>
              </>
            }
            isopen={paymentDetails}
            closeModal={handlePaymentDetails}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default StudentListDetail;
